import { BaseModel } from "./base-model.model";
import { OperacaoGarantida } from "./operacao-garantida.model";

export class Liberacao extends BaseModel {
    public data: Date;
    public valor: Number;
    public  valorEcg: Number;
    public  valorRedutorEcg: Number;
    public  operacao: OperacaoGarantida;
    
}